<template>
  <balance
    :title="title"
    :cols="headers"
    url="reports/balance"
    :defaultFilters="defaultFilters"
    ref="balance"
  />
</template>

<script>
import Balance from "@/views/panel/balance/Balance.vue"

export default {
  name: "ImprestBalance",
  components: { Balance },
  data() {
    return {
      defaultFilters: {
        level: 3,
        account_type: null,
        cols_count: 4,
        balance_status: "with_transaction",
      },
    };
  },
  computed: {
    title() {
      return 'صورت حساب کلی تنخواه'
    },
    headers() {
      return []
    }
  },
  methods: {
  },
};
</script>
